var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueMarkdown',{attrs:{"emoji":false,"inline":_vm.ignoreFormulas,"breaks":false,"source":_vm.source,"html":_vm.trustedContent,"plugins":_vm.ignoreFormulas ? [] : _vm.plugins}})}
var staticRenderFns = []

export { render, staticRenderFns }